import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';
import Style from './container.module.scss';

export const Container: FormContainerComponent = ({ children, title }) => {
  return (
    <div className={Style.container}>
      {title && (
        <div className={Style.title}>
          <p>{title}</p>
        </div>
      )}
      <div >{children}</div>
    </div>
  );
};
